export const COLORS = {
  LIGHT_RED: '#FF6666',
  RED: '#FF1A1A',
  BRIGHT_RED: '#EA4335',
  LIGHT_BLUE: '#99C5FF',
  BLUE: '#1A7DFF',
  ROYAL_BLUE: '#4285F4',
  OLD_FONT_BLUE: '#0000EE',
  GRAY: '#808080',
  BLACK: '#000000',
  GREEN: '#34A853',
  YELLOW: '#FBBC05',
  CINNABAR: '#EA4335',
  LIGHT_GREY: '#D3D3D3',
  WHITE: '#FFFFFF',
  ORANGE: '#FFA500',
  LIGHT_BROWN: '#C4A484',
  DEEP_BLUE: '#072BFC',
  MUTED_YELLOW: '#A69D1B',
  VIVID_CYAN: '#30CFFF',
  LIME_GREEN: '#05DF72',
  YELLOW_GREEN: '#6A8D09',
  PINK: '#e618ceff',
  DARK_ORANGE: '#c57906ff'
};
